import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ProjectStore} from "@app-web-central/web/project/data-access";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {SecurityService} from "@app-web-central/web/settings/data-access";
import {RouteUtil} from "@app-web-central/web/shared/utils";

@UntilDestroy()
@Component({
  selector: 'as-join-workspace',
  templateUrl: './join-workspace.component.html',
  styleUrls: ['./join-workspace.component.scss'],
})
export class JoinWorkspaceComponent implements OnInit {
  validationCode!: string;
  projectId!: string;
  loading!: boolean;
  organization!: string;
  projectLead!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _security: SecurityService,
    private _projectStore: ProjectStore
  ) { }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        if (params) {
          this.projectId = params["project"];
          this.validationCode = params["validation_code"];
          this.projectLead = params["invitor"];
          this.organization = params["organization"];

          if (!this._security.getCurrentSession().isConnected) {
            this._security.signOutSession();
          }
          if (!this.projectId && !this.validationCode) {
            if (this._security.getCurrentSession().isConnected) {
              this.router.navigateByUrl(RouteUtil.getHomeRouteUrl());
            } else {
              this._security.signOutSession();
            }
          }
        }
    });
  }

  acceptInvitation() {
    this.loading = true;
    this._projectStore.acceptInvitation({ projectId: this.projectId, validationCode: this.validationCode });
  }
}
